<template>
    <div class="container privacy">
        <h1>Política de Privacidade do FACILIMO.PT</h1>
        <h2>Política de Privacidade da Globiprincipio, Lda</h2>
        <p>A empresa Globiprincipio, Lda, entidade responsável pelo domínio <b>https://www.facilimo.pt/</b>, valoriza a privacidade dos seus visitantes e neste sentido compromete-se a respeitá-la, garantindo o sigilo e proteção dos dados registados pelos utilizadores.</p>
        <p>A presente Declaração de Privacidade tem como intuito assegurar aos utilizadores condições de Segurança e de Privacidade, sendo apenas solicitados e recolhidos os dados necessários à prestação do serviço, de acordo com as indicações explícitas no site. O utilizador tem plena liberdade para aceder aos seus dados, retificá-los ou eliminá-los.</p>
        <p>Assumimos para com os Utilizadores os seguintes compromissos:</p>
        <ul>
            <li>- Proceder ao tratamento de dados de forma lícita e leal, recolhendo apenas a informação necessária e pertinente à finalidade a que se destinam;
            </li>
            <li>- Permitir ao titular dos dados o acesso e correção das informações sobre si registadas;</li>
            <li>- Não utilizar os dados recolhidos para finalidade incompatível com a da recolha;</li>
            <li>- Manter os dados exatos e, se necessário, atuais;</li>
            <li>- Garantir gratuitamente o direito de eliminação dos dados utilizados quando requerida pelo titular;
            </li>
            <li>- Possuir mecanismos de segurança que impeçam a consulta, modificação, destruição ou adição dos dados
                por pessoa não autorizada a fazê-lo;
            </li>
            <li>- Não realizar interconexão de dados pessoais, salvo autorização legal.</li>
        </ul>

        <h3>Recolha de Dados Pessoais</h3>
        <p>O site <b>https://www.facilimo.pt/</b> pode ser visualizado, sem que seja necessário disponibilizar qualquer informação pessoal. Todavia, existem áreas - como a colocação de um pedido de serviço - que exigem a cedência de informação, sendo necessário que os utilizadores forneçam os seus dados pessoais, para que possam usufruir dos serviços disponibilizados.</p>
        <p>A recolha de dados de identificação do utilizador será efetuada através do preenchimento de um formulário de registo.</p>
        <p>O utilizador ao registar-se em <b>facilimo.pt</b> fornece dados pessoais, tais como o nome, endereço eletrónico, telefone, e-mail, código postal, etc., necessários para subscrever os serviços, as newsletters do site e as newsletters de parceiros associados.</p>


        <h3>Quando interage com a nossa Plataforma ou usa os nossos Serviços, recolhemos automaticamente os seguintes dados:</h3>
        <ol>
            <li>Informações do Dispositivo</li>
            <p>
                Recolhemos informações específicas do dispositivo tais como a versão do sistema operativo e o nome do operador móvel. Associamos os dados de identificação do dispositivo à sua conta Facilimo.
            </p>
            <li>
                Dados de Login do Utilizador
            </li>
            <p>
                Guardamos detalhes técnicos como o seu IP (Internet Protocol), localização do seu dispositivo, fuso horário e sistema operativo. Guardamos também o tipo e versão do seu navegador e a sua informação de Login, nomeadamente data de registo, data da última mudança de palavra-passe e data do último login com sucesso.
            </p>
            <li>
                Dados de Sequência de Cliques
            </li>
            <p>
                Recolhemos informações da sua atividade no Facilimo que incluem os sites a partir dos quais chegou à nossa plataforma, data e hora de cada visita, pesquisas feitas no Facilimo, duração da sua visita e a ordem pela qual visitou o conteúdo da plataforma.
            </p>
            <li>
                Cookies e Tecnologias Similares
            </li>
            <p>
                “Cookies” são pequenos ficheiros de texto transferidos por um servidor web para o armazenamento do seu dispositivo. Usamos cookies para gerir as sessões dos nossos utilizadores, armazenar as suas preferências de linguagem e mostrar-lhe anúncios relevantes para si.Os Cookies são usados para recolher a data e hora da sua visita, o seu histórico de pesquisas, as suas preferências e o seu username. Pode escolher bloquear no seu navegador toda ou uma parte do uso de cookies, ou que o mesmo alerte sobre quando os websites desejam utilizar cookies. Se desativar ou bloquear os cookies, lembre-se que parte do nosso serviço e plataforma podem ficar inacessíveis ou não funcionar adequadamente.
            </p>
        </ol>

        <h3>Dados recolhidos de terceiros ou de fontes disponíveis publicamente:</h3>
        <p>
            Recebemos dados pessoais sobre si das seguintes entidades terceiras (e serviços públicos):
        </p>
        <ul>
            <li>
                Fornecedores de dados técnicos e analisadores de dados de usabilidade: Google, Facebook, e Hotjar;
            </li>
            <li>
                Dados de navegação e de conversão, de prestadores de publicidade: Google, Facebook
            </li>
            <li>
                Sistema de notificações de Chat/SMS de fornecedores como GatewayAPI e Mailerlite.
            </li>
        </ul>
        <p>Entidades terceiras como a Google, podem exibir anúncios do <b>facilimo.pt</b> em sites da sua rede de conteúdos.</p>

        <h3>Registo de Utilizadores</h3>
        <p>O registo de utilizadores permite o acesso a vários serviços do facilimo.pt. O pedido de subscrição requer a introdução de um endereço de correio eletrónico e telefónico, para onde é enviado um link de confirmação que permitirá validar o registo efetuado. </p>
        <p>A palavra-chave é definida exclusivamente pelo utilizador e garante ao próprio um acesso exclusivo à gestão dos serviços.</p>
        <p>Os dados fornecidos pelos utilizadores serão apenas utilizados na realização dos serviços selecionados pelo utilizador para os quais foram facultados e para newsletters de parceiros associados, não sendo adicionados a outra lista, disponibilizados a outras entidades ou utilizados para enviar informação não relacionada.</p>

        <h3>Palavra-Chave</h3>
        <p>O acesso ao site <b>facilimo.pt</b> é condicionado por uma palavra-chave (password), que será indicada pelo utilizador no momento do registo. No caso de utilizadores não Profissionais, a palavras-chave é definida no primeiro acesso à sua area privada de gestão de projetos. No caso do utilizador esquecer a sua palavra-chave, poderá recuperar a mesma indicando o endereço de correio eletrónico (email) em que a conta ficou registada. Por motivos de segurança, a palavra-chave deverá ter mais de 6 caracteres.</p>
        <p><b>Recomendação:</b> Uma boa palavra-chave deve incluir letras, números e caracteres especiais, não devendo ser uma palavra comum ou facilmente detetável.</p>
        <p>A Palavra-Chave é pessoal e intransmissível. O uso que o utilizador faz da mesma é da sua total responsabilidade.</p>

        <h3>Outros Serviços</h3>
        <p>Outros serviços que possam surgir posteriormente e que requeiram a introdução de dados pessoais e/ou das respetivas entidades estão abrangidos pela politica de privacidade e segurança do FACILIMO referida neste documento.</p>

        <h3>Segurança e Qualidade da Informação</h3>
        <p>É nosso objetivo garantir a qualidade e integridade da informação fornecida pelos utilizadores do <b>facilimo.pt</b>, tendo neste sentido, sido implementadas as medidas necessárias, tanto ao nível tecnológico como organizacional, de forma a mantermos a informação segura, precisa, atualizada e completa.</p>
        <p>Para garantir a máxima segurança nas áreas do <b>facilimo.pt</b> onde são recolhidos os dados pessoais dos utilizadores, a sua transmissão é encriptada.</p>

        <h3>Partilha de informação pessoal</h3>
        <p>
            A informação pessoal recolhida em <b>https://www.facilimo.pt/</b> é utilizada para os fins indicados em cada caso.
        </p>

        <h3>Links</h3>
        <p>O <b>facilimo.pt</b> contém links para outros sites, sendo que o website não se responsabiliza pelas políticas de privacidade ou conteúdo desses sites.</p>

        <h3>Ficheiros de Registo Estatístico</h3>
        <p>São registados os endereços IP de todas as ligações efetuadas ao <b>facilimo.pt</b>. Esta informação será utilizada para efetuar análises estatísticas agregadas, não sendo estabelecida qualquer relação com os serviços e interações com os utilizadores.</p>
        <p>As análises efetuadas a partir da informação estatística agregada serão efetuadas para interpretar os padrões de utilização do site e melhorar, de forma contínua, os níveis de serviço e a satisfação do utilizador. A informação estatística agregada resultante das análises efetuadas poderá ser revelada a terceiros ou publicamente.</p>
        <p>Caso o <b>facilimo.pt</b> altere as suas práticas de privacidade, estas estarão sempre disponíveis neste local.</p>
        <p>Para esclarecimentos adicionais, por favor contacte o <b>suporte@facilimo.pt</b>.</p>

        <h3>Condições de Utilização</h3>
        <p>O <b>facilimo.pt</b> reserva-se o direito de anular o registo de qualquer utilizador que não cumpra os Termos e Condições de Utilização.</p>
        <p>Se tiver dúvidas, queixas ou comentários relativamente à nossa declaração ou política de privacidade, contacte-nos através do email
            <b>suporte@facilimo.pt</b>.</p>


    </div>
</template>

<script>
	import {scrollTop} from "../plugins/scrollTopMixin";

	export default {
		mixins: [scrollTop],

		data() {
    return {};
  },
  methods: {},
  created() {},
  destroyed() {}
};
</script>
<style scoped>
.privacy {
  padding: 6rem 0;
}
.privacy h1 {
  font-size: 2rem;
  font-weight: bold;
}
.privacy h2 {
  font-size: 1.25rem;
  font-weight: bold;
  padding: 2rem 0;
}
.privacy h3 {
  font-weight: bold;
  padding-top: 2rem;
}

.privacy p {
  text-align: justify;
}

.privacy li {
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/pages/Privacy.vue